module.exports = __webpack_public_path__ + "e2d48fb0d66b59da1f6606d302d170f4.png";